const MINUTES_IN_HOUR = 60;
function timeZoneOffsetInHours(offset) {
  const isNegative = offset < 0;
  const nonNegativeOffset = Math.abs(offset);
  const hours = String(Math.floor(nonNegativeOffset / MINUTES_IN_HOUR)).padStart(2, '0');
  const minutes = String(nonNegativeOffset % MINUTES_IN_HOUR).padStart(2, '0');
  return `${isNegative ? '-' : '+'}${hours}:${minutes}`;
}

function getConsentDateInISO8601Format({ date = new Date(), offset: offsetParam } = {}) {
  const currentDate = date;
  const offset = offsetParam || date.getTimezoneOffset();
  const dateString = currentDate.toISOString().split('.')[0];
  const timeZone = timeZoneOffsetInHours(offset);

  return `${dateString}${timeZone}`;
}

/**
 * Modifies a current date in consent date format
 * @param  {Date object} date
 * @return {Date} '2023-08-31T15:42:19+05:30'
 */

function getConsentDateInLocalTimeFormatWithTimeZone({
  date = new Date(),
  offset: offsetParam,
} = {}) {
  const currentDate = date;
  const offset = offsetParam || currentDate.getTimezoneOffset();
  const dateString = currentDate.toISOString().split('T')[0];
  const timeString = currentDate.toTimeString().split(' ')[0];

  const isNegative = offset < 0;
  const nonNegativeOffset = Math.abs(offset);
  const hours = String(Math.floor(nonNegativeOffset / MINUTES_IN_HOUR)).padStart(2, '0');
  const minutes = String(nonNegativeOffset % MINUTES_IN_HOUR).padStart(2, '0');
  const timeZone = `${isNegative ? '+' : '-'}${hours}:${minutes}`;

  return `${dateString}T${timeString}${timeZone}`;
}

module.exports = { getConsentDateInISO8601Format, getConsentDateInLocalTimeFormatWithTimeZone };
